import * as React from 'react';
import { FixMeLater } from '../../../utils';

export interface ModularPriceCurrencyProps {
    /**
     * The price's currency symbol.
     */
    children?: string;
}

export const ModularPriceCurrency: React.ForwardRefExoticComponent<
    ModularPriceCurrencyProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function ModularPriceCurrency(
    props: ModularPriceCurrencyProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { children, ...other } = props;
    return (
        <span ref={ref} data-currency={true} {...other}>
            {children}
        </span>
    );
});
